import React from 'react';

const FitGuide = () => {
  return (
    <section id="fit" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-[#333]">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-6">Fit Guide</h2>
          <p className="text-[#737373] text-lg uppercase font-bold tracking-wide mb-8">
            The SR-01 silhouette features a robust, structured upper. Precision engineered for street environments.
          </p>
          
          <div className="space-y-6">
            <div className="bg-[#111] p-6 border-l-4 border-acid">
              <h3 className="text-xl font-black uppercase mb-2">Sizing Recommendation</h3>
              <p className="text-[#737373]">Fits true to size. If you have a wider foot, we recommend going half a size up for optimal comfort during extended wear.</p>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="border border-[#333] p-4 text-center">
                <span className="block text-acid font-mono text-2xl mb-1">Standard</span>
                <span className="text-xs uppercase font-bold text-[#737373]">Width</span>
              </div>
              <div className="border border-[#333] p-4 text-center">
                <span className="block text-acid font-mono text-2xl mb-1">Low</span>
                <span className="text-xs uppercase font-bold text-[#737373]">Arch</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-[#111] border border-[#333] p-8 aspect-square flex flex-col justify-center items-center text-center">
          <div className="w-48 h-48 border-2 border-dashed border-[#333] rounded-full flex items-center justify-center mb-6 relative">
             <div className="w-full h-[2px] bg-acid absolute top-1/2 left-0 transform -translate-y-1/2"></div>
             <div className="h-full w-[2px] bg-acid absolute top-0 left-1/2 transform -translate-x-1/2"></div>
             <span className="text-[#333] font-black text-4xl uppercase opacity-50 absolute z-0">SR-01</span>
          </div>
          <p className="font-mono text-acid text-sm uppercase">Engineered Geometry</p>
        </div>
      </div>
    </section>
  );
};

export default FitGuide;